'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('../constants');

var _order_items = require('./order_items');

var _order_items2 = _interopRequireDefault(_order_items);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderList = _react2.default.createClass({
    displayName: 'OrderList',

    propTypes: {
        orders: _react.PropTypes.object.isRequired
    },
    render: function render() {
        var _this = this;

        var orders = this.props.orders;
        var items = orders.items,
            pagination = orders.pagination,
            error = orders.error,
            isFetching = orders.isFetching;

        var columns = [{
            render: function render(text, record, index) {
                return _react2.default.createElement(_order_items2.default, { key: index, order: record, showAction: true, handleClick: _this.props.handleClick });
            }
        }];
        var pager = Object.assign(_constants.PaginationConfig, {
            total: pagination.total,
            current: pagination.current_page,
            pageSize: pagination.per_page,
            onChange: function onChange(page, pageSize) {
                // 页码改变的回调，参数是改变后的页码及每页条数   
                _this.props.onChange(page);
            },
            onShowSizeChange: function onShowSizeChange(current, pageSize) {

            }
        });
        var tableConfig = {
            columns: columns,
            locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
            dataSource: items,
            showHeader: false,
            loading: isFetching,
            pagination: pager,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };

        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = OrderList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/order_list.js
// module id = 1014
// module chunks = 0